export default "__VITE_ASSET__B1telG9Q__"